import { useEffect, useState } from 'react';
import { useTheme } from '@src/theme/useTheme';
import { loadSeason } from '@src/theme/registry';
import { isSeason } from '@src/theme/season';
import { gamePictureIds } from '@src/theme/gamePictures';
import type { SeasonPackage } from '@src/theme/types';
import { ThemeIcon } from '@src/theme/ThemeIcon';
import { PackageIcon } from '@src/components/icons/PackageIcon';

/** Render historical artwork without changing the page's theme or styles. */
export function ActivityPicture({
  picture,
  logo,
  theme,
}: {
  picture?: string;
  logo?: string | null;
  theme?: string | null;
}) {
  const { seasonPackage } = useTheme();
  const [loaded, setLoaded] = useState<SeasonPackage | null>(null);
  const artwork = seasonPackage.id === theme ? seasonPackage : loaded?.id === theme ? loaded : null;
  useEffect(() => {
    if (logo || !isSeason(theme) || seasonPackage.id === theme) return;
    let cancelled = false;
    loadSeason(theme)
      .then((result) => {
        if (!cancelled) setLoaded(result);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [theme, logo, seasonPackage.id]);
  if (logo) return <img src={logo} alt="" />;
  const id = gamePictureIds.find((id) => id === picture);
  if (!artwork || !id) return <ThemeIcon name="box" fallback={<PackageIcon />} />;
  return <img src={artwork.gamePictures[id]} alt="" />;
}
